import * as React from 'react';
import { ModalFullscreen } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import { INewbuildingMapPin } from '../../types/map';
import { NewbuildingsMap } from '../NewbuildingsMap';
import * as styles from './styles.css';

export interface INewbuildingsMapModalProps {
  apiKey: string;
  pins: INewbuildingMapPin[];
  onClose(): void;
  onPinClick(pin: INewbuildingMapPin): void;
}

export function NewbuildingsMapModal({
  apiKey,
  pins,
  onClose,
  onPinClick,
}: INewbuildingsMapModalProps): React.JSX.Element {
  return (
    <ModalFullscreen escape open portal theme="white" onClose={onClose}>
      <div className={styles['container']} data-testid="newbuildings-map-modal">
        <NewbuildingsMap apiKey={apiKey} pins={pins} onPinClick={onPinClick} />
        <button
          aria-label="Закрыть"
          className={styles['close']}
          data-testid="newbuildings-map-close"
          type="button"
          onClick={onClose}
        >
          <IconActionClose16 color="icon-inverted-default" />
        </button>
      </div>
    </ModalFullscreen>
  );
}
